export default __webpack_public_path__ + "static/3p8-autocomplete-143d16e002bfe1c6164835fe2d5c7c0e.png";